(function () {
  'use strict';

  angular
    .module('vcMain')
    .config(config);

  function config($urlRouterProvider) {
    $urlRouterProvider.otherwise('/login');
  }
}());
